module.exports = __webpack_public_path__ + "static/media/emptyList.0f22e994.svg";